export default __webpack_public_path__ + "media/images/de-637ec89ab052cad77631c380a72dae96.svg";